import { Helmet } from "react-helmet-async"
import {
	ITransportServiceProvider,
	TransportServiceProviderTravelActivityBookings,
} from "./../../../../TransportServiceProviders"
import { useOutletContext } from "react-router"

export default function TransportServiceProviderBookingsPage() {
	const { transportServiceProvider } = useOutletContext<{
		transportServiceProvider: ITransportServiceProvider
		revalidate: () => void
	}>()
	return (
		<>
			<Helmet>
				<title>Travel Activity Bookings | TSP</title>
			</Helmet>
			<TransportServiceProviderTravelActivityBookings
				transportServiceProvider={transportServiceProvider}
			/>
		</>
	)
}
